<template>
  <v-layout wrap>
    <v-flex
      v-for="(option, index) in cards"
      :key="index"
      xs6
      md4
      pr-4
      pb-4
    >
      <router-link :to="option.route">
        <icon-card
          :background-icon-color="option.backgroundIconColor"
          :icon="option.icon"
          :icon-color="option.iconColor"
          :text="option.text"
        />
      </router-link>
    </v-flex>
  </v-layout>
</template>

<script>

import IconCard from 'Support/components/cards/IconCard.vue';
import ModalitiesConfigRequest from 'Domain/modalities/ModalitiesConfigRequest';
import BuildCardsMixin from 'Support/mixins/BuildCardsMixin';

export default {
  name: 'Modalities',
  components: {
    IconCard,
  },
  mixins: [BuildCardsMixin],
  data: () => ({
    payload: null,
    cards: [],
  }),
  created() {
    this.getModalitiesInfo();
  },
  methods: {
    getModalitiesInfo() {
      const loader = this.$loading.show();
      ModalitiesConfigRequest.list()
        .then(({ data }) => {
          const { content } = data;
          content.forEach((element) => {
            this.cards.push(
              this.buildCardOption('mdi-calendar-today',
                this.$t('app.modalities.cardTitle', { dias: element.numeroDeDiasDePrazoParaProrrogacao }),
                `/modalities/config/${element.id}`),
            );
          });
        })
        .catch(() => {})
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>

<style>
  a {
    text-decoration: none;
  }
</style>
